import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Difference } from './components/Difference';
import { BeforeAfter } from './components/BeforeAfter';
import { Pricing } from './components/Pricing';
import { HowItWorks } from './components/HowItWorks';
import { QuoteForm } from './components/QuoteForm';
import { SpanishBanner } from './components/SpanishBanner';
import { Footer } from './components/Footer';
const SEO = {
  title: 'Nítido Pro | Professional Cleaning in Orlando, Kissimmee & Broward',
  description: 'Premium move-out, deep cleaning, post-construction and commercial cleaning services in Orlando, Kissimmee, Broward & surrounding areas in Florida. Get a fast quote on WhatsApp.'
};
function setMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
function setOg(property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('property', property);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
function applySeo() {
  // HTML <title> + meta title
  document.title = SEO.title;
  setMeta('title', SEO.title);
  setMeta('description', SEO.description);
  // Open Graph
  setOg('og:title', SEO.title);
  setOg('og:description', SEO.description);
  setOg('og:type', 'website');
  setOg('og:site_name', 'Nítido Pro');
  // Twitter / X card
  setMeta('twitter:card', 'summary_large_image');
  setMeta('twitter:title', SEO.title);
  setMeta('twitter:description', SEO.description);
}
// Run as early as possible (on module load, before first paint) so external
// tools that read the title shortly after load get the correct value instead
// of any stale default project title.
if (typeof document !== 'undefined') {
  applySeo();
}
export function App() {
  useEffect(() => {
    applySeo();
  }, []);
  return <div className="min-h-screen bg-ink font-body text-paper selection:bg-lime selection:text-ink" data-id="element-0" data-mp="d57dixer88gf">
      <Navbar data-id="element-1" data-mp="85bbv4tj4t41" />
      <main data-id="element-2" data-mp="86mgf6usu4w7">
        <Hero data-id="element-3" data-mp="864atjm8yebm" />
        <Services data-id="element-4" data-mp="86cqfj9r7xqi" />
        <Difference data-id="element-5" data-mp="3gle7udba4tcj" />
        <BeforeAfter data-id="element-6" data-mp="3gkv01pfcflc8" />
        <Pricing data-id="element-7" data-mp="3gmfuzg5kl6am" />
        <HowItWorks data-id="element-8" data-mp="3glwabrojc3sw" />
        <QuoteForm data-id="element-9" data-mp="3gj1sm7wwox36" />
        <SpanishBanner data-id="element-10" data-mp="3bmjqlfsyncuj" />
      </main>
      <Footer data-id="element-11" data-mp="3bnmh3mmdfd9x" />
    </div>;
}